import "../../css/react-image-gallery.css";
import "../../css/serviceAlbum.css";

import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { styleInputImageForm } from "./styles";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import Input from "@material-ui/core/Input";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import "../../../src/css/serviceAlbum.css";
import Modal from "@material-ui/core/Modal";
class InputFileReader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: "",
      value: "",
      flagEdit: false,
      file: null,
      anchorEl: null,
    };
    this.handleClick = this.handleClick.bind(this);
    this.inputFileChanged = this.inputFileChanged.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
    this.setState({ src: this.props.defaultImg });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultImg !== this.props.defaultImg) {
      this.setState({ src: nextProps.defaultImg });
    }
  }

  inputFileChanged(e) {
    if (e.target.files[0]) {
      if (window.FileReader) {
        let file = e.target.files[0],
          reader = new FileReader(),
          self = this;
        reader.onload = function (r) {
          self.setState({
            src: r.target.result,
          });
        };
        reader.readAsDataURL(file);
        self.setState({
          value: reader,
          file: e.target.files[0],
          flagEdit: true,
        });
        if (this.props.type === "notPreview") {
          this.props.update(e.target.files[0]);
        }
      } else {
        alert("Sorry, your browser does'nt support for preview");
      }
    }
  }
  handleDelete = () => {
    this.setState({
      file: null,
      anchorEl: null,
      src: "",
      flagEdit: true,
    });
    if (this.props.type === "notPreview") {
      this.props.delete();
    }
  };
  getFlagEdit = () => {
    return this.state.flagEdit;
  };
  getFile = () => {
    return this.state.file;
  };
  getSrc = () => {
    return this.state.src;
  };
  handleClick = (event) => {
    const { disabled = false } = this.props;
    if (!disabled) this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };
  handleUpdate = () => {
    let input = this.refs.input_reader;
    input.click();
    this.setState({
      anchorEl: null,
    });
  };
  handleSelect = () => {
    this.Upload && this.Upload.open();
    this.setState({
      anchorEl: null,
    });
  };
  reset = () => {
    this.setState({
      src: this.props.defaultImg,
      value: "",
      flagEdit: false,
      file: null,
      anchorEl: null,
    });
  };
  imageSelect = (image) => {
    this.Upload && this.Upload.close();
    if (this.props.selectStorageMode) {
      if (this.props.type === "notPreview" && this.props.imageSelect)
        this.props.imageSelect(image);
      else
        this.setState({
          file: null,
          anchorEl: null,
          src: image,
          flagEdit: true,
        });
    }
  };
  getFlagEdit = () => {
    return this.state.flagEdit;
  };
  getFile = () => {
    return this.state.file;
  };
  getSrc = () => {
    return this.state.src;
  };
  deleteImage = () => {
    this.setState({
      src: "",
      file: null,
    });
  };
  handleOpenModal = (url) => {
    this.setState({
      openModal: true,
      selectImage: url,
      startIndex: 0,
      showingIndex: 0,
    });
  };
  render() {
    const { classes } = this.props;
    let { src = "" } = this.state;
    return (
      <div className={classes.container}>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openModal || false}
          onClose={this.handleCloseModal}
        >
          <div
            className={classes.imageItem}
            style={{
              backgroundImage: `url(${src || "/images/noneImage.svg"})`,
              backgroundSize: "cover",
              width: "100%",
              height: "100%",
            }}
          ></div>
        </Modal>
        {src ? (
          <div className={classes.listItem + " list-item-image-album"}>
            <div className="bg-hover-image-album">
              <div className="bg-hover-image-album-icon">
                {/* <IconButton
                  className={classes.buttonHover + " f-left"}
                  onClick={() => this.handleOpenModal(src)}
                  aria-label="Zoom"
                >
                  <Icon
                    className={classes.iconHover + " fa fa-arrows-alt"}
                    color="inherit"
                  />
                </IconButton> */}
                <IconButton
                  className={classes.buttonHover + " f-right"}
                  onClick={() => this.deleteImage()}
                  aria-label="Delete"
                >
                  <Icon
                    className={classes.iconHover + " fa fa-trash"}
                    color="inherit"
                  />
                </IconButton>
              </div>
            </div>
            <div
              className={classes.imageItem}
              style={{
                backgroundImage: `url(${src})`,
                backgroundSize: "cover",
                width: "100%",
                height: "100%",
              }}
            ></div>
          </div>
        ) : (
          <div className={classes.listItem}>
            <IconButton
              className={classes.buttonIcon}
              onClick={() => document.getElementById("add-image").click()}
              aria-label="Add"
            >
              {/* <Icon className={classes.icon} color="primary" >
                                        add_circle
                                    </Icon>    */}
              <CameraAltIcon className={classes.icon} />
            </IconButton>
            <Input
              className={classes.inputImage}
              disableUnderline
              id="add-image"
              type="file"
              margin="none"
              onChange={this.inputFileChanged}
            />
            {/* <div
              className={classes.imageItem}
              style={{
                backgroundImage: `url(${src || "/images/noneImage.svg"})`,
                backgroundSize: "cover",
              }}
            ></div> */}
          </div>
        )}
      </div>
    );
  }
}
InputFileReader.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
InputFileReader.defaultProps = {
  accept: "image/*",
  capture: true,
  multiple: false,
};
InputFileReader.propTypes = {
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  capture: PropTypes.bool,
  multiple: PropTypes.bool,
};
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styleInputImageForm, { withTheme: true })(InputFileReader)
  )
);
